import { sendGTMEvent } from '@next/third-parties/google';

export namespace GTM {
    /** Google Tag Manager ID */
    export const ID = 'GTM-W2S7NFX';

    /** A map of known GTM events and their expected data type */
    export type KnownEvents = {
        funkeyCheckoutFinished: Record<string, unknown>;
        funkeyContactFormSubmit: Record<string, unknown>;
        funkeyEventFormSubmit: Record<string, unknown>;
    };

    export function setUserData(email: string): void {
        if (typeof window !== 'undefined' && window.gtag && email) {
            if (typeof window !== 'undefined' && window.location.href.includes('localhost')) return;

            window.gtag('set', 'user_data', {
                email: email,
            });
        }
    }

    export function sendEvent<T extends keyof GTM.KnownEvents>(
        eventName: T,
        data: GTM.KnownEvents[T],
    ): void {
        if (typeof window !== 'undefined' && window.location.href.includes('localhost')) return;

        return sendGTMEvent({
            ...data,
            event: eventName,
        });
    }
}
